import { FunctionComponent } from 'react';
import { HeartIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'next-i18next';

interface Props {
  lives: number;
  showSolution: () => void;
}

const Lives: FunctionComponent<Props> = ({ lives, showSolution }: Props) => {
  const { t } = useTranslation('common');
  return (
    <div className="flex justify-between items-center">
      {lives > 0 && (
        <div className="flex items-center">
          <p className="text-white mr-1">{t('challenges.intents')}</p>
          {[2, 1, 0].map((item) => (
            <div key={`intents-${item}`}>
              {item < lives ? (
                <HeartIcon className="h-5 w-5 text-red-500" />
              ) : (
                <HeartIcon className="h-5 w-5 text-gray-500" />
              )}
            </div>
          ))}
        </div>
      )}

      {lives === 0 && (
        <button
          className="inline-block rounded-sm  bg-platzi-dark-second duration-300 text-xs font-bold capitalize px-4 py-2 tooltip opacity-90 hover:opacity-100 cursor-pointer"
          type="button"
          onClick={() => showSolution()}
          disabled={lives > 0}
        >
          {t('codeRunner.solution')}
          {lives > 0 && (
            <span className="text-sm font-light text-gray-300 tooltiptext">
              {lives} {t('codeRunner.tooltip')}
            </span>
          )}
        </button>
      )}
    </div>
  );
};

export default Lives;
